export default {
  // Kế toán viên
  Accountant: 6,
  // Kế toán trưởng
  ChiefAccountant: 3,
  // Thủ trưởng
  CompanyDirector: 2,
  // Ủy quyền KTT
  DelegateChiefAccountant: 5,
  // Ủy quyền CTK
  DelegateHeadOfDepartment: 4,
};
